import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { AuthUserContext } from './../context';
import withFirebase from './withFirebase';
import * as ROUTES from './../constants/routes';

const withAuthorization = (condition) => (Component) => {
  class WithAuthorization extends React.Component {
    componentDidMount() {
      this.listener = this.props.firebase.onAuthUserListener(
        (authUser) => {
          if (!condition(authUser)) {
            this.props.history.push(ROUTES.LANDING);
          }
        },
        () => this.props.history.push(ROUTES.LANDING)
      );
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      /** Lo que hace este decorador, es usar AuthUserContext, ver si el usuario cumple la condicion (que se pasa en el momento de uso)
       * Si es asi retorna el componente con los props correspondientes y sino null.
       */
      return (
        <AuthUserContext.Consumer>
          {(authUser) =>
            condition(authUser) ? <Component {...this.props} /> : null
          }
        </AuthUserContext.Consumer>
      );
    }
  }

  return compose(withRouter, withFirebase)(WithAuthorization);
};

export default withAuthorization;
